import { BenefitDTOBenefitEnum, TenantDTO } from 'probonio-shared-ui/api';
import { useBenefitSettings } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import {
  BenefitMetadataExtensionInterface,
  getBenefitMetadataForced,
} from '../../extension/interface/benefit-metadata.extension.interface';
import { isBenefitActive } from './isBenefitActive';

export function useOrderedBenefitExtensions(
  tenant: TenantDTO | undefined,
  benefitsToExclude?: BenefitDTOBenefitEnum[],
): {
  orderedBenefits: BenefitMetadataExtensionInterface[];
  activeBenefits: BenefitMetadataExtensionInterface[];
  inactiveBenefits: BenefitMetadataExtensionInterface[];
} {
  const { orderedBenefits, activeBenefits, inactiveBenefits } = useOrderedBenefits(tenant, benefitsToExclude);

  return useMemo(
    () => ({
      orderedBenefits: orderedBenefits.map(benefit => getBenefitMetadataForced(benefit)),
      activeBenefits: activeBenefits.map(benefit => getBenefitMetadataForced(benefit)),
      inactiveBenefits: inactiveBenefits.map(benefit => getBenefitMetadataForced(benefit)),
    }),
    [activeBenefits, inactiveBenefits, orderedBenefits],
  );
}

export function useOrderedBenefits(tenant: TenantDTO | undefined, benefitsToExclude?: BenefitDTOBenefitEnum[]) {
  const { benefits } = useBenefitSettings();
  return useMemo(() => {
    const activeBenefits: BenefitDTOBenefitEnum[] = [];
    const inactiveBenefits: BenefitDTOBenefitEnum[] = [];
    benefits.forEach(benefit => {
      if (benefitsToExclude?.includes(benefit)) {
        return;
      }

      if (isBenefitActive(tenant, benefit)) {
        activeBenefits.push(benefit);
      } else if (
        (benefit !== BenefitDTOBenefitEnum.Coupons && benefit !== BenefitDTOBenefitEnum.Gifts) ||
        !isBenefitActive(tenant, BenefitDTOBenefitEnum.CouponsV2)
      ) {
        inactiveBenefits.push(benefit);
      }
    });
    return { orderedBenefits: activeBenefits.concat(inactiveBenefits), activeBenefits, inactiveBenefits };
  }, [benefits, benefitsToExclude, tenant]);
}
